import React from 'react'

import SSpyContainer from 'components/_special/SSpyContainer'
import SSpyHandler from 'components/_special/SSpyHandler'
import SSpySection from 'components/_special/SSpySection'
import FaqAccordion from 'components/FaqAccordion'
import SectionWrapper from 'components/SectionWrapper'
import { LocalizationContext } from 'contexts/Localization'
import { H1Small as H1 } from 'styles/components/typography'

class Faq extends SSpyContainer {
  render() {
    const { locale, dict } = this.context
    const { sectionsRefs, sceneActiveIndex, texts } = this.state

    return (
      <SectionWrapper className="ss-container__wrapper">
        <div className="row">
          <div className="ss-container__container col-12 col-md-8 col-lg-9">
            <div className="pr-lg-5 pt-2 pt-md-0">
              <H1 dangerouslySetInnerHTML={{ __html: dict.block_faq.title }} />
              {texts.list.map((item, key) => (
                <SSpySection
                  ref={sectionsRefs[key]}
                  key={`item.${key}`}
                  title={item.title}
                  isActive={sceneActiveIndex === key}
                >
                  <FaqAccordion
                    onChange={this.handleUpdateActiveScene}
                    locale={locale}
                    items={item.list}
                    sectionIndex={key}
                  />
                </SSpySection>
              ))}
            </div>
          </div>
          <div className="col-md-4 col-lg-3">
            <SSpyHandler
              sceneActiveIndex={sceneActiveIndex}
              swiperRef={this.swiperRef}
              sectionsRefs={sectionsRefs}
              items={texts.list}
            />
          </div>
        </div>
      </SectionWrapper>
    )
  }
}

Faq.contextType = LocalizationContext

export default Faq
